/**
 * Sync stacked card heights for the editorial explore list.
 * On desktop, CSS stretch handles equal heights, so inline styles are reset.
 */
(function initLvzEditorialExploreList() {
	var STACKED_LAYOUT_MEDIA_QUERY = '(max-width: 1023px)';
	var resizeTimer = null;

	if (window.__lvzEditorialExploreListInitialized) {
		return;
	}
	window.__lvzEditorialExploreListInitialized = true;

	/**
	 * @param {Element} section
	 * @returns {HTMLElement[]}
	 */
	function getWrappers(section) {
		var region = section.querySelector('.lvz-explore-list__region');
		if (!region) {
			return [];
		}

		return Array.prototype.slice.call(region.children);
	}

	/**
	 * @param {Element} section
	 */
	function resetSectionHeights(section) {
		getWrappers(section).forEach(function (wrapper) {
			wrapper.style.minHeight = '';

			var card = wrapper.querySelector(':scope > .lvz-explore-list-card');
			if (card) {
				card.style.minHeight = '';
			}
		});
	}

	/**
	 * @returns {boolean}
	 */
	function isStackedLayout() {
		return window.matchMedia(STACKED_LAYOUT_MEDIA_QUERY).matches;
	}

	/**
	 * @param {Element} section
	 */
	function syncSectionHeights(section) {
		var wrappers = getWrappers(section);
		if (!wrappers.length) {
			return;
		}

		resetSectionHeights(section);

		if (!isStackedLayout()) {
			return;
		}

		var maxHeight = wrappers.reduce(function (currentMax, wrapper) {
			return Math.max(currentMax, Math.ceil(wrapper.getBoundingClientRect().height));
		}, 0);

		if (!maxHeight) {
			return;
		}

		wrappers.forEach(function (wrapper) {
			wrapper.style.minHeight = maxHeight + 'px';

			var card = wrapper.querySelector(':scope > .lvz-explore-list-card');
			if (card) {
				card.style.minHeight = maxHeight + 'px';
			}
		});
	}

	function syncAllSections() {
		document.querySelectorAll('[data-lvz-explore-list="true"]').forEach(function (section) {
			syncSectionHeights(section);
		});
	}

	function scheduleSync() {
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(syncAllSections, 80);
	}

	function bindImageListeners() {
		document.querySelectorAll('[data-lvz-explore-list="true"] .lvz-explore-list-card__img').forEach(function (img) {
			if (img.dataset.lvzExploreListBound === 'true') {
				return;
			}

			img.dataset.lvzExploreListBound = 'true';
			img.addEventListener('load', scheduleSync, { passive: true });
			img.addEventListener('error', scheduleSync, { passive: true });
		});
	}

	function boot() {
		bindImageListeners();
		syncAllSections();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	window.addEventListener('load', scheduleSync, { passive: true });
	window.addEventListener('resize', scheduleSync, { passive: true });
	window.addEventListener('orientationchange', scheduleSync, { passive: true });

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(scheduleSync);
	}
})();
